
import React, { useState, useEffect } from "react";
import { Navigation } from "@/components/Navigation";
import { Footer } from "@/components/Footer";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import {Trophy, Crown, Zap, Briefcase, Star, Users, Award, Filter, Search, Flame, LucideProps} from "lucide-react";
import { SEO } from "@/components/SEO";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { categories } from "@/data/categories";
import {
  Pagination,
  PaginationContent,
  PaginationEllipsis,
  PaginationItem,
  PaginationLink,
  PaginationNext,
  PaginationPrevious
} from "@/components/ui/pagination";
import {Clan} from "@/types/Clan.ts";
import {useQuery} from "@tanstack/react-query";
import {League} from "@/types/League.ts";
import {LeagueClanInterface} from "@/types/LeagueClanInterface.ts";
import * as LucideIcons from "lucide-react";

type IconComponent = React.FC<LucideProps>;

function isIconComponent(icon): icon is IconComponent {
  return typeof icon === "function" || typeof icon === "object";
}
const Leagues = () => {
  /*const [leagues, setLeagues] = useState<League[]>([
    {
      name: "Legends League",
      icon: <Crown className="h-6 w-6 text-white" />,
      criteria: "Top 3 clans for at least 6 months (Min 3M bp)",
      benefits: "Poll points +5% bp, 20000 bp joining bonus",
      color: "#F9F7FE",
      iconBgColor: "#3182CE",
      shadowColor: "rgba(49, 130, 206, 0.3)",
      clans: [
        { id: 1, name: "Elite Squad", total_points: 1250000, categories: ["Technology", "Sports", "Economy"] },
        { id: 2, name: "Cosmic Voters", total_points: 980000, categories: ["News", "Politics", "Entertainment"] },
        { id: 3, name: "AlphaPolls", total_points: 805000, categories: ["Technology", "Finance", "Gaming"] },
      ]
    },
    {
      name: "Champions League",
      icon: <Trophy className="h-6 w-6 text-white" />,
      criteria: "Top 10 clans after first 3 (min 1M bp)",
      benefits: "Poll points +3.2% bp, 7000 bp joining bonus",
      color: "#E5F4EA",
      iconBgColor: "#469857",
      shadowColor: "rgba(70, 152, 87, 0.3)",
      clans: [
        { id: 4, name: "PollStars", total_points: 700000, categories: ["Technology", "Entertainment"] },
        { id: 5, name: "VoteVanguard", total_points: 650000, categories: ["Politics", "Economy", "News"] },
        { id: 6, name: "PollPioneers", total_points: 580000, categories: ["Sports", "Entertainment", "Gaming"] },
        { id: 7, name: "BlankVoters", total_points: 540000, categories: ["Technology", "Finance"] },
      ]
    },
    {
      name: "Chaos League",
      icon: <Zap className="h-6 w-6 text-white" />,
      criteria: "Clans with 500K+ bp",
      benefits: "Poll points +2% bp, 3000 bp joining bonus",
      color: "#FFF7DE",
      iconBgColor: "#CC9019",
      shadowColor: "rgba(204, 144, 25, 0.3)",
      clans: [
        { id: 8, name: "PollPanthers", total_points: 520000, categories: ["Sports", "Politics", "Finance"] },
        { id: 9, name: "VotingVipers", total_points: 510000, categories: ["Technology", "Gaming"] },
      ]
    },
    {
      name: "Professionals League",
      icon: <Briefcase className="h-6 w-6 text-white" />,
      criteria: "Clans with 250K-500K bp",
      benefits: "Poll points +2.5% bp, 5000 bp joining bonus",
      color: "#ECF6D8",
      iconBgColor: "#344F16",
      shadowColor: "rgba(52, 79, 22, 0.3)",
      clans: [
        { id: 10, name: "PollPro", total_points: 450000, categories: ["Technology", "Finance"] },
        { id: 11, name: "VoteVeterans", total_points: 380000, categories: ["Politics", "News"] },
        { id: 12, name: "BlankElite", total_points: 320000, categories: ["Sports", "Entertainment"] },
      ]
    },
    {
      name: "Rising Stars League",
      icon: <Star className="h-6 w-6 text-white" />,
      criteria: "Clans with 100K-250K bp",
      benefits: "Poll points +1.5% bp, 1500 bp joining bonus",
      color: "#F1F0FB",
      iconBgColor: "#155231",
      shadowColor: "rgba(21, 82, 49, 0.3)",
      clans: [
        { id: 13, name: "PollRising", total_points: 240000, categories: ["Technology", "Gaming"] },
        { id: 14, name: "VoteValiance", total_points: 180000, categories: ["Entertainment", "Sports"] },
        { id: 15, name: "BlankBrigade", total_points: 120000, categories: ["Finance", "Politics"] },
      ]
    },
    {
      name: "Amateur League",
      icon: <Users className="h-6 w-6 text-white" />,
      criteria: "All clans below 100K bp",
      benefits: "Standard bp, no gift",
      color: "#F1F1F1",
      iconBgColor: "#3182CE",
      shadowColor: "rgba(49, 130, 206, 0.2)",
      clans: [
        { id: 16, name: "PollNewbies", total_points: 90000, categories: ["Technology", "Entertainment"] },
        { id: 17, name: "VoteVentures", total_points: 75000, categories: ["Sports", "Gaming"] },
        { id: 18, name: "BlankBeginners", total_points: 50000, categories: ["News", "Politics"] },
      ]
    }
  ]);*/

  // Amateur league clans with more data for pagination
  /*const amateurLeagueClans: Clan[] = [
    { id: 16, name: "PollNewbies", total_points: 90000, categories: ["Technology", "Entertainment"] },
    { id: 17, name: "VoteVentures", total_points: 75000, categories: ["Sports", "Gaming"] },
    { id: 18, name: "BlankBeginners", total_points: 50000, categories: ["News", "Politics"] },
    { id: 19, name: "NoviceVoters", total_points: 48000, categories: ["Entertainment", "Economy"] },
    { id: 20, name: "PollRookies", total_points: 45000, categories: ["Sports", "Technology"] },
    { id: 21, name: "VotingFreshers", total_points: 42000, categories: ["Politics", "Finance"] },
    { id: 22, name: "BlankStarters", total_points: 39000, categories: ["Gaming", "News"] },
    { id: 23, name: "PollApprentices", total_points: 36000, categories: ["Technology", "Entertainment"] },
    { id: 24, name: "VotingLearners", total_points: 33000, categories: ["Sports", "Finance"] },
    { id: 25, name: "BlankTrainees", total_points: 30000, categories: ["Politics", "News"] },
    { id: 26, name: "PollGreenhorns", total_points: 27000, categories: ["Gaming", "Technology"] },
    { id: 27, name: "VotingNovices", total_points: 24000, categories: ["Finance", "Entertainment"] },
    { id: 28, name: "BlankInitiates", total_points: 21000, categories: ["Sports", "Politics"] },
    { id: 29, name: "PollEntrants", total_points: 18000, categories: ["News", "Technology"] },
    { id: 30, name: "VotingAmateurs", total_points: 15000, categories: ["Gaming", "Finance"] },
  ];*/

  const [filterBy, setFilterBy] = useState<"name" | "category">("name");
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [filteredClans, setFilteredClans] = useState<LeagueClanInterface[]>([]);

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const [paginatedClans, setPaginatedClans] = useState<LeagueClanInterface[]>([]);
  const [filteredLeagues, setFilteredLeagues] = useState<League[]>([]);
  const {data: leagues, isLoading: isLeaguesLoading} = useQuery({
    queryKey: ['leagues'],
    queryFn: async () => {
      const response = await fetch(`${import.meta.env.VITE_API_URL}/leagues`);
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const responseData = await response.json();
      // console.log("category response:", responseData)
      return responseData;
    }
  });

  const {data: clans, isLoading: isClansLoading} = useQuery({
    queryKey: ['clans'],
    queryFn: async () => {
      const response = await fetch(`${import.meta.env.VITE_API_URL}/clans`);
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const responseData = await response.json();
      // console.log("category response:", responseData)
      return responseData;
    }
  });

  useEffect(() => {
    if(leagues){
      setFilteredLeagues(leagues);
    }
  }, [leagues]);
/*

  useEffect(() => {
    // Update leagues with more amateur clans
    const updatedLeagues = [...leagues];
    if (updatedLeagues[5]) {
      updatedLeagues[5] = {
        ...updatedLeagues[5],
        clans: amateurLeagueClans
      };
      setLeagues(updatedLeagues);
    }
  }, []);
*/

  useEffect(() => {
    if (!filteredLeagues[5]) return;

    const amateurLeague = filteredLeagues[5];
    let filtered = [...amateurLeague.clans];

    // Apply filters
    if (filterBy === "name" && searchQuery) {
      filtered = filtered.filter(clan =>
        clan.name.toLowerCase().includes(searchQuery.toLowerCase())
      );
    } else if (filterBy === "category" && selectedCategory) {
      filtered = filtered.filter(clan =>
        clan.categoryNames.includes(selectedCategory)
      );
    }

    setFilteredClans(filtered);
  }, [searchQuery, selectedCategory, filterBy, leagues]);

  // Apply pagination
  useEffect(() => {
    if (filteredClans.length === 0) return;

    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = Math.min(startIndex + itemsPerPage, filteredClans.length);

    setPaginatedClans(filteredClans.slice(startIndex, endIndex));
  }, [filteredClans, currentPage, itemsPerPage]);

  // Calculate total pages
  const totalPages = Math.ceil((filteredClans.length || 0) / itemsPerPage);

  // Generate page numbers to display
  const getPageNumbers = () => {
    const pageNumbers = [];
    const maxVisiblePages = 5;

    if (totalPages <= maxVisiblePages) {
      // Show all pages if there are fewer than maxVisiblePages
      for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(i);
      }
    } else {
      // Always show first page
      pageNumbers.push(1);

      // Calculate middle pages
      let startPage = Math.max(2, currentPage - 1);
      let endPage = Math.min(totalPages - 1, currentPage + 1);

      // Adjust if we're near the start or end
      if (currentPage <= 3) {
        endPage = Math.min(totalPages - 1, 4);
      } else if (currentPage >= totalPages - 2) {
        startPage = Math.max(2, totalPages - 3);
      }

      // Add ellipsis if needed
      if (startPage > 2) {
        pageNumbers.push("ellipsis-start");
      }

      // Add middle pages
      for (let i = startPage; i <= endPage; i++) {
        pageNumbers.push(i);
      }

      // Add ellipsis if needed
      if (endPage < totalPages - 1) {
        pageNumbers.push("ellipsis-end");
      }

      // Always show last page
      pageNumbers.push(totalPages);
    }

    return pageNumbers;
  };

  // Pagination handlers
  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  const handlePrevious = () => {
    if (currentPage > 1) {
      setCurrentPage(prev => prev - 1);
    }
  };

  const handleNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage(prev => prev + 1);
    }
  };

  return (
    <>
      <SEO
        title="Leagues"
        description="View league rankings and see where your clan stands"
        type="website"
        name="blankpoll"
        imageUrl="/blankpoll-banner.jpg"
      />
      <Navigation />
      <main className="min-h-screen pt-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <h1 className="text-4xl font-bold text-center mb-3">Leagues</h1>
          <p className="text-gray-600 dark:text-gray-400 text-center mb-10">Compete with other clans to climb up the
            league ladder and earn more rewards</p>

          {/*<div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mt-8 mb-4">
            <div className="flex items-center gap-2">
              <Filter className="h-5 w-5 text-gray-500"/>
              <span className="font-medium">Filter by:</span>
            </div>
            <div className="flex flex-wrap gap-3">
              <button
                  className={`px-3 py-1.5 rounded text-sm ${filterBy === 'name' ? 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200' : 'bg-gray-100 dark:bg-gray-700'}`}
                  onClick={() => {
                    setFilterBy('name');
                    setSelectedCategory("");
                  }}
              >
                Clan Name
              </button>
              <button
                  className={`px-3 py-1.5 rounded text-sm ${filterBy === 'category' ? 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200' : 'bg-gray-100 dark:bg-gray-700'}`}
                  onClick={() => {
                    setFilterBy('category');
                    setSearchQuery("");
                  }}
              >
                Category
              </button>
            </div>
          </div>*/}

          {/*<div className="mb-6">
            {filterBy === "name" ? (
                <div className="relative">
                  <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-500"/>
                  <Input
                      type="text"
                      placeholder="Search clans by name..."
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                      className="pl-10"
                  />
                </div>
            ) : (
                <Select value={selectedCategory} onValueChange={setSelectedCategory}>
                  <SelectTrigger>
                    <SelectValue placeholder="Select category"/>
                  </SelectTrigger>
                  <SelectContent>
                    {categories.map((category) => (
                        <SelectItem key={category.slug} value={category.name}>
                          {category.name}
                        </SelectItem>
                    ))}
                  </SelectContent>
                </Select>
            )}
          </div>*/}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {filteredLeagues?.sort((a, b) => (b.level) - (a.level)).map((league, index) => {
              const Icon = LucideIcons[league.icon as keyof typeof LucideIcons];
              return (
                  <Card
                      key={index}
                      className="flex flex-col h-full overflow-hidden border border-dashed border-gray-200 dark:border-gray-700"
                      style={{
                        backgroundColor: league.color,
                        color: 'inherit',
                        boxShadow: `6px 6px 0 0 ${league.shadowColor}`
                      }}
                  >
                    <div className="bg-transparent dark:bg-gray-800 flex flex-col h-full">
                      <CardHeader className="flex flex-col pb-2">
                        <div className="flex items-center gap-3">
                          <div className="p-2.5 rounded-full relative" style={{
                            backgroundColor: league.iconBgColor,
                            boxShadow: "2px 2px 0 0 #1A385F"
                          }}>
                            {isIconComponent(Icon) ? <Icon className="h-5 w-5 text-white"/> : null}
                          </div>
                          <div>
                            <CardTitle className="text-xl font-bold">{league.name}</CardTitle>
                            <CardDescription className="text-sm mt-1 dark:text-gray-400">
                              {league.criteria.map(criteria => criteria.description)}
                            </CardDescription>
                            <div className="flex items-center mt-2 text-sm">
                              <Award className="h-4 w-4 mr-1.5 text-gray-600 dark:text-gray-400"/>
                              <span className="font-medium">{league.benefits}</span>
                            </div>
                          </div>
                        </div>
                      </CardHeader>
                      <CardContent className="flex-1 pt-4 flex flex-col justify-between">
                        <div className="overflow-x-auto">
                          <Table>
                            <TableHeader>
                              <TableRow>
                                <TableHead className="w-[200px]">Clan Name</TableHead>
                                <TableHead>Total Points</TableHead>
                                <TableHead>Categories</TableHead>
                              </TableRow>
                            </TableHeader>
                            <TableBody>
                              {(league.clans?.length > 0) ? league.clans?.map((clan) => (
                                  <TableRow key={clan.name}>
                                    <TableCell className="font-medium">{clan.name}</TableCell>
                                    <TableCell>{clan.totalPollPoints.toLocaleString()}</TableCell>
                                    <TableCell>
                                      <div className="flex flex-wrap gap-1.5">
                                        {clan.categoryNames.map((category, i) => (
                                            <span key={i}
                                                  className="px-2 py-1 bg-gray-100 dark:bg-gray-700 text-xs rounded-md">
                                      {category}
                                    </span>
                                        ))}
                                      </div>
                                    </TableCell>
                                  </TableRow>
                              )) : (
                                  <TableRow key={"empty"}>
                                    <TableCell colSpan={999} className={"w-full text-center px-2 mx-2"}>
                                      There is nothing to see here!
                                    </TableCell>
                                  </TableRow>
                              )}
                            </TableBody>
                          </Table>
                        </div>
                      </CardContent>
                    </div>
                  </Card>
              )
            })}
          </div>

          {/*<div className="grid grid-cols-1 gap-6 mt-6">
            {(filteredLeagues && filteredLeagues.length > 0) && (
                <Card
                    className="overflow-hidden border border-dashed border-gray-200 dark:border-gray-700"
                    style={{
                      backgroundColor:filteredLeagues[4].color,
                      color: 'inherit',
                      boxShadow: `6px 6px 0 0  ${filteredLeagues[4].shadowColor}`
                    }}
                >
                  <div className="bg-transparent dark:bg-gray-800">
                    <CardHeader className="flex flex-col pb-2">
                      <div className="flex items-center gap-3">
                        <div className="p-2.5 rounded-full" style={{
                          backgroundColor: filteredLeagues[4].iconBgColor,
                          boxShadow: "2px 2px 0 0 #1A385F"
                        }}>
                          {filteredLeagues[4].icon}
                        </div>
                        <div>
                          <CardTitle className="text-xl font-bold">{filteredLeagues[4].name}</CardTitle>
                          <CardDescription className="text-sm mt-1 dark:text-gray-400">
                            {filteredLeagues[4].criteria}
                          </CardDescription>
                          <div className="flex items-center mt-2 text-sm">
                            <Award className="h-4 w-4 mr-1.5 text-gray-600 dark:text-gray-400" />
                            <span className="font-medium">{filteredLeagues[4].benefits}</span>
                          </div>
                        </div>
                      </div>
                    </CardHeader>
                    <CardContent className="pt-4">
                      <div className="overflow-x-auto">
                        <Table>
                          <TableHeader>
                            <TableRow>
                              <TableHead className="w-[200px]">Clan Name</TableHead>
                              <TableHead>Total Points</TableHead>
                              <TableHead>Categories</TableHead>
                            </TableRow>
                          </TableHeader>
                          <TableBody>
                            {filteredLeagues[4].clans.map((clan) => (
                                <TableRow key={clan.id}>
                                  <TableCell className="font-medium">{clan.name}</TableCell>
                                  <TableCell>{clan.totalPollPoints.toLocaleString()}</TableCell>
                                  <TableCell>
                                    <div className="flex flex-wrap gap-1.5">
                                      {clan.categories.map((category, i) => (
                                          <span key={i} className="px-2 py-1 bg-gray-100 dark:bg-gray-700 text-xs rounded-md">
                                    {category}
                                  </span>
                                      ))}
                                    </div>
                                  </TableCell>
                                </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </div>
                    </CardContent>
                  </div>
                </Card>
            )}
          </div>*/}


          {/*<div className="grid grid-cols-1 gap-6">
            <Card
              className="overflow-hidden border border-dashed border-gray-200 dark:border-gray-700"
              style={{
                backgroundColor: filteredLeagues[5].color,
                color: 'inherit',
                boxShadow: `6px 6px 0 0 ${filteredLeagues[5].shadowColor}`
              }}
            >
              <div className="bg-transparent dark:bg-gray-800">
                <CardHeader className="flex flex-col pb-2">
                  <div className="flex items-center gap-3">
                    <div className="p-2.5 rounded-full" style={{
                      backgroundColor: filteredLeagues[5].iconBgColor,
                      boxShadow: "2px 2px 0 0 #1A385F"
                    }}>
                      {filteredLeagues[5].icon}
                    </div>
                    <div>
                      <CardTitle className="text-xl font-bold">{filteredLeagues[5].name}</CardTitle>
                      <CardDescription className="text-sm mt-1 dark:text-gray-400">
                        {filteredLeagues[5].criteria}
                      </CardDescription>
                      <div className="flex items-center mt-2 text-sm">
                        <Award className="h-4 w-4 mr-1.5 text-gray-600 dark:text-gray-400" />
                        <span className="font-medium">{filteredLeagues[5].benefits}</span>
                      </div>
                    </div>
                  </div>
                </CardHeader>
                <CardContent className="pt-4">
                  <div className="overflow-x-auto">
                    <Table>
                      <TableHeader>
                        <TableRow>
                          <TableHead className="w-[200px]">Clan Name</TableHead>
                          <TableHead>Total Points</TableHead>
                          <TableHead>Categories</TableHead>
                        </TableRow>
                      </TableHeader>
                      <TableBody>
                        {(paginatedClans.length > 0 ? paginatedClans : []).map((clan) => (
                          <TableRow key={clan.id}>
                            <TableCell className="font-medium">{clan.name}</TableCell>
                            <TableCell>{clan.totalPollPoints.toLocaleString()}</TableCell>
                            <TableCell>
                              <div className="flex flex-wrap gap-1.5">
                                {clan.categories.map((category, i) => (
                                  <span key={i} className="px-2 py-1 bg-gray-100 dark:bg-gray-700 text-xs rounded-md">
                                    {category}
                                  </span>
                                ))}
                              </div>
                            </TableCell>
                          </TableRow>
                        ))}
                        {filteredClans.length === 0 && searchQuery && filterBy === "name" && (
                          <TableRow>
                            <TableCell colSpan={3} className="text-center py-4">
                              No clans found with that name
                            </TableCell>
                          </TableRow>
                        )}
                        {filteredClans.length === 0 && selectedCategory && filterBy === "category" && (
                          <TableRow>
                            <TableCell colSpan={3} className="text-center py-4">
                              No clans found in this category
                            </TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                  </div>

                   Pagination Controls
                  {filteredClans.length > 0 && (
                    <div className="mt-4">
                      <Pagination>
                        <PaginationContent>
                          <PaginationItem>
                            <PaginationPrevious
                              onClick={handlePrevious}
                              className={currentPage === 1 ? "pointer-events-none opacity-50" : "cursor-pointer"}
                            />
                          </PaginationItem>

                          {getPageNumbers().map((page, index) => (
                            typeof page === 'number' ? (
                              <PaginationItem key={index}>
                                <PaginationLink
                                  isActive={page === currentPage}
                                  onClick={() => handlePageChange(page)}
                                >
                                  {page}
                                </PaginationLink>
                              </PaginationItem>
                            ) : (
                              <PaginationItem key={page}>
                                <PaginationEllipsis />
                              </PaginationItem>
                            )
                          ))}

                          <PaginationItem>
                            <PaginationNext
                              onClick={handleNext}
                              className={currentPage === totalPages ? "pointer-events-none opacity-50" : "cursor-pointer"}
                            />
                          </PaginationItem>
                        </PaginationContent>
                      </Pagination>
                      <div className="text-center text-sm text-gray-500 mt-2">
                        Showing {paginatedClans.length} of {filteredClans.length} clans
                      </div>
                    </div>
                  )}
                </CardContent>
              </div>
            </Card>
          </div>*/}
        </div>
      </main>

      {/* Call to Action Banner */}
      <div className="w-full py-8 mt-8"
           style={{
             background: 'linear-gradient(90deg, rgba(240,247,255,1) 0%, rgba(156,195,230,0.8) 68%, rgba(105,174,232,1) 100%)',
             borderTop: '1px solid rgba(226, 232, 240, 0.8)'
           }}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6">
            <div className="flex items-center">
              <div className="p-4 rounded-full bg-orange-500 mr-5" style={{
                boxShadow: "6px 6px 0 0 rgba(194, 65, 12, 0.5)"
              }}>
                <Flame className="h-8 w-8 text-white"/>
              </div>
            </div>
            <div className="flex-1 text-center md:text-left">
              <h3 className="text-2xl font-bold text-gray-800 mb-2">Compete & Climb the Ranks!</h3>
              <p className="text-gray-700 max-w-2xl">
                Join competitions, predict poll outcomes accurately, and help your clan rise through the league
                rankings.
                Higher leagues mean more rewards, bonus points, and exclusive benefits. Start your journey to the
                Legends League today!
              </p>
            </div>
          </div>
        </div>
      </div>

      <Footer/>
    </>
  );
};

export default Leagues;
